import { gql } from "@apollo/client";

export const GET_ALL_WATER_SYSTEMS = gql`
 query GetWaterSystemMenu {
  getWaterSystemMenu {
    value
    label
  }
  }
`;

export const GET_ALL_INSTITUTIONS = gql`
  query GetAllInstitutions {
  getAllInstitutions {
    umd_id
    institutionId
    institutionName
  }
}
`;

export const GET_ALL_LHD = gql`
  query GetAllLHD {
  getAllLHD {
    umd_id
    lhd_id
    lhd_name
  }
}
`;

export const REQUEST_ACCESS = gql`
  mutation RequestAccess($input: userAccountRequestInput!) {
    requestAccess(userAccountRequestInput: $input)
  }
`;